// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 757 ? "maplibre-gl" : chunkId) + "." + {"358":"1be20438","659":"f6b03104","757":"c3a7736b"}[chunkId] + ".chunk.js";
};